<template>
  <v-btn icon @click="deletarItem()">
    <v-icon title="Deletar Item">mdi-delete</v-icon>
  </v-btn>
</template>

<script>
import { mapMutations } from 'vuex';
import { deletarItemCotacaoPedido } from "../CotacaoApi";

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapMutations({
      SET_PRODUTOS_COTACAO_PEDIDO: "CotacaoCarrinhoCompra/SET_PRODUTOS_COTACAO_PEDIDO",
      SET_COTACOES_ID_PEDIDO: "CotacaoCarrinhoCompra/SET_COTACOES_ID_PEDIDO",
      SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO: "CotacaoCarrinhoCompra/SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO"
    }),
    deletarItem() {
      const parametros = {
        idpedido: this.item.idpedido,
        id_cotacao: this.item.id_cotacao,
        idproduto: this.item.idproduto
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        deletarItemCotacaoPedido(parametros)
          .then((retorno) => {
            this.SET_COTACOES_ID_PEDIDO(retorno.ids);
            this.SET_PRODUTOS_COTACAO_PEDIDO(retorno.produtos);
            this.SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO([]);
          })
          .catch(() => this.Helpers.logout())
      );
    }
  }
}
</script>

<style>

</style>
